import React from 'react';
import { DropdownFieldProps, DropdownFieldOption } from '../../types/interface';
import { Dropdown, DisplayText } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import { DeviceTypeBadges } from '../DeviceTypeBadges';
import { getMarginLeft } from '../../utils/MdmUtils';

const DropdownField = ({
  intl,
  value,
  onChange,
  disabled = false,
  options,
  label,
  level,
  attributeDescription = '',
  supportedDeviceTypes = [],
  showDeviceTypeBadges = false,
  isParentSectionHovered = false,
  uiDataProp = null,
  minOsVersion
}: DropdownFieldProps) => {
  const shouldShowBadge =
    showDeviceTypeBadges && supportedDeviceTypes.length > 0;

  // Apply localization to options
  const localizedOptions = options.map((option) => ({
    ...option,
    label: getTranslatedText(intl, option.label)
  }));

  const selectedOption =
    localizedOptions.find((option) => option.value == value) ||
    localizedOptions[0] ||
    null;

  const handleChange = (selectedOption: DropdownFieldOption | null) => {
    if (selectedOption) {
      onChange(selectedOption.value);
    }
  };

  return (
    <div>
      <div
        className={`flex ${getMarginLeft(level)} ${
          uiDataProp?.vertical ? 'col g5' : 'actr g20'
        }`}
      >
        <div className={`${!uiDataProp?.vertical ? 'w350' : ''}`}>
          <DisplayText
            element="p"
            size="large"
            weight={uiDataProp?.vertical ? 'Regular' : 'Medium'}
          >
            <span style={{ color: 'var(--sops-label-color)' }}>
              {getTranslatedText(intl, label)}
            </span>
          </DisplayText>
        </div>
        <div className="flex actr g10">
          <div className={`${!uiDataProp?.vertical ? 'w200' : 'fw'}`}>
            <Dropdown
              value={selectedOption}
              onChange={handleChange}
              disabled={disabled}
              options={localizedOptions}
              styles={{
                menuPortal: (base: React.CSSProperties) => ({
                  ...base,
                  zIndex: 9999
                }),
                menu: (base: React.CSSProperties) => ({ ...base, zIndex: 9999 })
              }}
              menuPlacement="auto"
              menuPosition="fixed"
              uiDataProp={uiDataProp}
            />
          </div>
          <DeviceTypeBadges
            intl={intl}
            supportedDeviceTypes={supportedDeviceTypes}
            shouldShow={shouldShowBadge && isParentSectionHovered}
          />
        </div>
        {uiDataProp?.helpText && (
          <DisplayText size="large" variant="subdued">
            {getTranslatedText(intl, uiDataProp.helpText)}
          </DisplayText>
        )}
      </div>
      {attributeDescription && (
        <div className="mt5">
          <DisplayText element="p" size="medium" variant="subdued">
            {getTranslatedText(intl, attributeDescription, { minOsVersion })}
          </DisplayText>
        </div>
      )}
    </div>
  );
};

export default DropdownField;
